const CookieService = {
  COOKIE_CONNECT_WALLET: "flare_space_connectWallet",
  COOKIE_ACCOUNT_TYPE: "flare_space_accountType",
  COOKIE_ACCOUNT: "flare_space_account",
  CHAIN_KEY: "flare_space_chain",
  allDeletableCookies: ["flare_space_connectWallet", "flare_space_accountType", "flare_space_account", "flare_space_chain"],
  getCookie: (name: string) => {
    const lsValue = sessionStorage.getItem(name);

    if (CookieService.isCookiesEnabled()) {
      const cookie = document.cookie.split(";");
      name = name + "=";

      for (let i = 0; i < cookie.length; i++) {
        let c = cookie[i];

        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }

        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length) === "" ? null : c.substring(name.length, c.length);
        }
      }
      return null;
    }

    return lsValue;
  },

  setCookie: (name: string, value: any, expiresMs = 365 * 24 * 60 * 60 * 1000) => {
    if (!value) {
      CookieService.deleteCookie(name);
      sessionStorage.removeItem(name);
    } else {
      sessionStorage.setItem(name, value);

      if (CookieService.isCookiesEnabled() || name === CookieService.COOKIE_CONNECT_WALLET) {
        const d = new Date();
        d.setTime(d.getTime() + expiresMs);
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + (value ? value : "") + ";expires=" + expires + ";path=/;SameSite=Strict;Secure";
      }
    }
  },

  isCookiesEnabled: () => {
    const name = CookieService.COOKIE_CONNECT_WALLET + "=";
    const cookie = document.cookie.split(";");

    for (let i = 0; i < cookie.length; i++) {
      let c = cookie[i];

      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length) === "" ? false : c.substring(name.length, c.length);
      }
    }

    return false;
  },

  deleteCookie: (name: string) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;";
  },
  deleteCookies: () => {
    CookieService.allDeletableCookies.forEach((cookieName) => {
      CookieService.deleteCookie(cookieName);
      sessionStorage.removeItem(cookieName);
    });
  },
};

export default CookieService;
